import { useAuth0 } from '@auth0/auth0-react';

export const useAuth = () => {
  const {
    user,
    isAuthenticated,
    isLoading,
    loginWithRedirect,
    logout,
  } = useAuth0();

  const handleLogin = () => loginWithRedirect();
  const handleLogout = () => logout({
    logoutParams: {
      returnTo: window.location.origin,
    },
  });

  return {
    user,
    isAuthenticated,
    isLoading,
    login: handleLogin,
    logout: handleLogout,
    userId: isAuthenticated && user?.sub ? user.sub : 'notauthenticated',
  };
};